import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/empty-screen.svg'


const _withScopeId = n => (_pushScopeId("data-v-634c56ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-screen" }
const _hoisted_2 = { class: "empty-screen__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "You currently don’t have any Subscription")
], -1))
const _hoisted_5 = { class: "empty-screen__footer" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageMemberEmptyScreen',
  props: {
  allowButton: Boolean,
  headingText: String,
},
  emits: ["openNewProject"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const onClickNewProject = () => {
  emits("openNewProject");
};
const props = __props;
console.log("propssss", props);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (props.allowButton)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "button button-purple",
              onClick: onClickNewProject,
              block: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Upgrade Plan ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})